import { render, staticRenderFns } from "./SafeCenter.vue?vue&type=template&id=3e54ece8&scoped=true&"
import script from "./SafeCenter.vue?vue&type=script&lang=js&"
export * from "./SafeCenter.vue?vue&type=script&lang=js&"
import style0 from "./SafeCenter.vue?vue&type=style&index=0&id=3e54ece8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54ece8",
  null
  
)

export default component.exports